var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjsiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 24,
    viewBox: "0 0 98 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1133 0.00991821H97.3185V3.81H89.3033V23.8017H85.2954V3.81H77.1133V0.00991821Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8833 0.00991821V3.81H27.6875V9.92316H40.7122V13.7232H27.6875V20.0016H43.8833V23.8017H23.6799V3.81H23.6782V0.00991821H43.8833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9723 0.0198517H48.7275L67.5131 23.8116H72.7731L63.3792 11.9239L72.7581 0.0380033L67.5131 0.0462623L60.7533 8.60092L53.9723 0.0198517Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3543 17.0144L56.7278 13.6869L48.7126 23.8298H53.9724L59.3543 17.0144Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8203 23.8017L5.00952 0H0V23.7918H4.00762V5.08548L18.7857 23.8017H23.8203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsiconwhite);
export default __webpack_public_path__ + "static/media/nextjsiconwhite.9ba7bdf823a795b073bc9c12a7cbab01.svg";
export { ForwardRef as ReactComponent };